import axios from "axios";
import User from "models/User";
import { GenericService, Service } from "./genericService";
import Genders from "../models/Enums/Genders";

class ProfilService extends GenericService<User> implements Service<User> {
  constructor() {
    super("api/user");
  }

  updateProfil = async (firstName: string, lastName: string, birthDay: Date, email: string, phoneNumber: string, gender: Genders): Promise<void> => {
    await axios.post<any>(`${this.baseUrl}/profil`,
      {
        firstName,
        lastName,
        birthDay,
        email,
        phoneNumber,
        gender
      });
  }

  updateProfilPicture = async (base64: string): Promise<string> => {
    return (await axios.post(`${this.baseUrl}/picture`,
      {
        value: base64
      })).data;
  }

  addPersonalPicture = async (base64: string): Promise<string> => {
    return (await axios.post(`${this.baseUrl}/personal`,
      {
        value: base64
      })).data;
  }

  removePersonalPicture = async (path: string): Promise<void> => {
    await axios.delete(`${this.baseUrl}/personal/${path}`);
  }

  addDescription = async (description: string): Promise<void> => {
    await axios.post<any>(`${this.baseUrl}/description`,
      {
        value: description
      });
  }

  addDestination = async (destination: string): Promise<void> => {
    await axios.post<any>(`${this.baseUrl}/destination/add`,
      {
        value: destination
      });
  }

  removeDestination = async (destination: string): Promise<void> => {
    await axios.post<any>(`${this.baseUrl}/destination/delete`,
      {
        value: destination
      });
  }

  addStayType = async (stayType: string): Promise<void> => {
    await axios.post<any>(`${this.baseUrl}/stayType/add`,
      {
        value: stayType
      });
  }

  removeStayType = async (stayType: string): Promise<void> => {
    await axios.post<any>(`${this.baseUrl}/stayType/delete`,
      {
        value: stayType
      });
  }

  addTransport = async (transport: string): Promise<void> => {
    await axios.post<any>(`${this.baseUrl}/transport/add`,
      {
        value: transport
      });
  }

  removeTransport = async (transport: string): Promise<void> => {
    await axios.post<any>(`${this.baseUrl}/transport/delete`,
      {
        value: transport
      });
  }
}

export default new ProfilService();
